import { render } from "./workshopChart.vue?vue&type=template&id=f4b2a5be"
import script from "./workshopChart.vue?vue&type=script&lang=js"
export * from "./workshopChart.vue?vue&type=script&lang=js"

import "./workshopChart.vue?vue&type=style&index=0&id=f4b2a5be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__